import React from 'react'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { PaperProps as MuiPaperProps } from '@material-ui/core/Paper'
import { default as MuiPaper } from '@material-ui/core/Paper'
import type { StyleClasses } from '../../styles'

const useStyles = makeStyles<Theme, PaperProps>(
  (_theme) => ({
    root: {
      '@media print': {
        boxShadow: 'none !important'
      }
    }
  }),
  { name: 'Paper' }
)

export interface PaperProps extends Omit<MuiPaperProps, 'classes'> {
  classes?: StyleClasses<typeof useStyles>
}

// Forwards its ref: DropdownSelect reads its menu Paper's DOM node to tell a focus move inside the
// portaled menu from one that leaves it. Without the ref that read null, and a second pick in a
// multi-select closed the menu and lost the pick (ENG-2237).
const Paper = React.forwardRef<HTMLDivElement, PaperProps>(function Paper(props, ref) {
  const classes = useStyles(props)

  return <MuiPaper classes={classes} {...props} ref={ref} />
})

export default Paper
